import { render, staticRenderFns } from "./ServiceTypeForm.vue?vue&type=template&id=fa721cac&"
import script from "./ServiceTypeForm.vue?vue&type=script&lang=js&"
export * from "./ServiceTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTypeForm.vue?vue&type=style&index=0&id=fa721cac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports